import { trpc } from "../trpc";

export function useCurrentUser() {
  const user = trpc.user.user.useQuery();

  return {
    user: user.data,
    isLoading: user.isLoading,
  };
}
